module.exports = __webpack_public_path__ + "img/hr-sand-dune-decal-23.fee183b5.png";